<div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-0 ps-0">
        <div class="container-fluid">
            <div class="default_class">
                <div class="content-wrapper p-0">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card rounded shadow-lg">
                                    <div class="card-header  headerbg" style="border-bottom:3px solid #d8eff8;">
                                        <h5 class="mb-0 ">Founder Dashboard</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="row dashboardcards">



                                            <!-- Approved -->
                                            <div class="col-md-3 col-sm-6">
                                                <div class="card shadow text-center">
                                                    <div class="card-body">
                                                        <div class="progress-circle approved">
                                                            <span class="progress-value">{{listGrid?.approved}}</span>
                                                        </div>
                                                        <div class="progress-label">Approved</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Rejected -->
                                            <div class="col-md-3 col-sm-6">
                                                <div class="card shadow text-center">
                                                    <div class="card-body">
                                                        <div class="progress-circle rejected">
                                                            <span class="progress-value">{{listGrid?.rejected}}</span>
                                                        </div>
                                                        <div class="progress-label">Rejected</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Waiting Confirmation -->
                                            <div class="col-md-3 col-sm-6">
                                                <div class="card shadow text-center">
                                                    <div class="card-body">
                                                        <div class="progress-circle waiting">
                                                            <span
                                                                class="progress-value">{{listGrid?.in_progress}}</span>
                                                        </div>
                                                        <div class="progress-label">In Progress</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- In Progress -->
                                            <div class="col-md-3 col-sm-6">
                                                <div class="card shadow text-center">
                                                    <div class="card-body">
                                                        <div class="progress-circle in-progress">
                                                            <span class="progress-value">{{listGrid?.total}}</span>
                                                        </div>
                                                        <div class="progress-label">Total Start-ups</div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="col-xl-12 mt-2">
                                                <div class="card mb-2">
                                                    <div class="card-body">
                                                        <h5 style="color: #ff7f50; font-weight: bold;">Welcome, Founder!</h5>
                                                        <p> This is your personalized space to manage
                                                            and track your startup journey. Here, you can submit your
                                                            startup idea, choose up to three relevant incubators, and
                                                            monitor the status of your submission - whether it's under
                                                            review, approved, or rejected. Once submitted, your idea
                                                            will be securely shared with the selected incubators for
                                                            evaluation. You’ll also be able to view detailed feedback,
                                                            including ratings and comments provided by the incubators.
                                                            Please note, only one idea can be submitted at a time until
                                                            it’s reviewed. Use this dashboard to stay updated, refine
                                                            your vision, and connect with the right ecosystem to bring
                                                            your innovation to life.
                                                        </p>
                                                        <a href="" class="text-danger"><i
                                                                class="bi bi-camera-video-fill"></i> Video</a>
                                                        &nbsp;
                                                        <a href="" class="text-danger"><i
                                                                class="bi bi-file-earmark-pdf-fill"></i>
                                                            PDF</a> &nbsp;

                                                    </div>

                                                </div>


                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>